import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { escutarInstalacao } from './lib/instalar';
import '@waymail/ui/styles.css';

// Antes do primeiro render: o navegador avisa uma vez so, e cedo.
escutarInstalacao();

const root = document.getElementById('root');
if (!root) throw new Error('Elemento #root nao encontrado no documento.');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// O shell offline (Secao 11) so existe na build: em dev o Vite serve os modulos
// um a um, e um service worker no meio disso atrapalha o recarregamento.
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    // Falhar aqui nao pode derrubar o app: sem service worker ele so perde o
    // modo offline.
    void navigator.serviceWorker.register('/sw.js').catch(() => undefined);
  });
}
